<template>
  <div class="payment-failed-page">
    <div class="payment-failed-container">
      <div class="icon-section">
        <i class="far fa-times-circle" />
      </div>
      <div class="failed-text-container">
        <div class="failed-description-text">ทำรายการชำระเงินไม่สำเร็จ</div>
        <div class="failed-reason-text" v-if="failedReason">เนื่องจาก {{ failedReason }}</div>
      </div>
      <div class="back-homepage-btn-container">
        <Button class="back-homepage-btn" @click.native="reProceedCheckout">ทำรายการใหม่</Button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import Button from '@/components/Button'

export default {
  name: 'PaymentFailed',
  data: () => ({
    failedReason: '',
  }),
  props: ['type', 'application_id'],
  components: {
    Button,
  },
  mounted() {
    if (this.type === 'credit-card') {
      const reason = _.get(this.$route, 'query.reason', '')

      this.failedReason = reason
    }
  },
  methods: {
    reProceedCheckout() {
      if (this.type === 'credit-card') {
        return this.$router.push(`/payment/credit-card/${this.application_id}`)
      }
    },
  },
}
</script>

<style lang="scss">
.payment-failed-page {
  padding-top: 48px;

  .payment-failed-container {
    background-color: #fff;
    margin: 0 auto;
    padding: 32px;
    text-align: center;
    width: 90%;

    .icon-section {
      color: #e23737;
      font-size: 100px;
      margin-bottom: 16px;
    }

    .failed-text-container {
      margin-bottom: 16px;

      .failed-description-text {
        font-size: 18px;
        line-height: 22px;
        margin-bottom: 4px;
      }

      .failed-reason-text {
        font-size: 14px;
        line-height: 18px;
      }
    }

    .back-homepage-btn-container {
      margin-top: 24px;
      text-align: center;
    }
  }
}
</style>
